<div class="close-btn" (click)="onConfirmClick()">
    <img src="../../../../assets/images/smallclose.svg" />
</div>
<div class="modal-div-container">
    <div class="step-heading">
        <b>What is PAN ?</b>
    </div>
    <div class="step">
        A Permanent Account Number known as PAN is a vital document for any taxpayer. It is a unique 10-character string
        of letters and digits. PAN card requirements are detailed in the Income Tax Act of 1961.
    </div>
    <div class="step-dark">
        A PAN card is a mandatory requirement for all tax-paying individuals, partnerships, companies, etc. It also
        serves as an identity proof for a number of purposes.
    </div>
    <div class="step-heading">
        <b>Sample Business Card </b>
    </div>
    <div class="step-5">
        <img mat-card-image src="../../../../assets/images/pan-report.png" alt="Photo">
    </div>
</div>